import { Component, OnInit, forwardRef, Input, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import moment from 'moment';

import { DemoozModalComponent, DemoozButtonComponent } from '@demooz/components';
import { DataService, OperationService } from '@app/services';
import { Question } from '@app/models';

@Component({
    selector: 'app-news-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    imports: [
        IonIcon, TranslatePipe, forwardRef(() => DemoozModalComponent), forwardRef(() => DemoozButtonComponent)
    ]
})
export class NewsQuestionComponent  implements OnInit {
      
    @Input({alias : 'question', required : true}) question: Question;
    @Output() onAnswerQuestion = new EventEmitter<Question>();
      
    @ViewChild('modalAnswers') modalAnswers: DemoozModalComponent;
     
    questionAuthor: string = '';
    nbAnswers: number = 0;
    questionAnswered: boolean = false;
      
    constructor(        
        private domSanitizer: DomSanitizer,
        public translateService: TranslateService,
        public dataService: DataService,
        private operationService: OperationService
    ) { }

    ngOnInit() {
        
    }
        
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['question'] && changes['question'].currentValue){
            this.initQuestion();
        }
    }
    
    initQuestion(){
        this.questionAuthor = this.question.tester.firstName+' '+this.question.tester.lastName.charAt(0).toUpperCase()+'.';
        this.question.responses = this.question.responses.filter(r => r.response.length > 0);
        this.question.responses.sort((a,b) => {
            let aDate = moment(new Date(parseInt(a.responseDate)));
            let bDate = moment(new Date(parseInt(b.responseDate)));
            let order=0;
            if(aDate < bDate){
                order = 1;
            }
            else if (aDate > bDate){
                order = -1;
            }
            return order;
        });
        this.nbAnswers = this.question.responses.length;
        this.questionAnswered = (this.question.responses.find(r => r.ambassadorID === this.dataService.ambassador.value.ID) !== undefined);
    }
    
    getAnswerDate(responseDate: string): string{
        return moment(new Date(parseInt(responseDate))).format('DD/MM/YYYY');
    }
    
    async answerQuestion(){
        this.onAnswerQuestion.emit(this.question);
    }
    
    seeAllAnswers(){
        this.modalAnswers.open();
    }
    
    onDidDismissModalAnswers($event: any){
        
    }
}
